import { arrayOf, func, string } from "prop-types";
import React, { useEffect } from "react";

import styled from "styled-components";

import FnrIcon from "UI/FnrIcon";

import { colorIsLight } from "Utilities/Colors/colorUtils";

import { checkForGradientMatch } from "./utils/checkForGradientMatch";
import { getPickerGradients } from "./utils/getPickerGradients";

function GradientSelector({ color, initialGradient, onSelect }) {
  const allGradients = getPickerGradients(color);
  const initialGradientIndex = allGradients.findIndex((gradientOption) =>
    checkForGradientMatch(initialGradient, gradientOption)
  );

  const [selectedGradientIndex, setSelectedGradientIndex] = React.useState(initialGradientIndex !== -1 ? initialGradientIndex : 0);

  useEffect(() => {
    const handler = setTimeout(() => {
      const gradientOption = allGradients[selectedGradientIndex];
      if (onSelect) {
        onSelect(gradientOption);
      }
    }, 200);

    // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.
    return () => {
      clearTimeout(handler);
    };
  }, [color]);

  return (
    <Wrapper data-cy="Gradient_Selector" data-color={color}>
      {allGradients.map((gradientOption, index) => {
        const gradientStyle = {
          background: `linear-gradient(135deg, ${gradientOption.join(", ")})`,
          width: "100%",
          aspectRatio: "1",
          borderRadius: "5px",
          cursor: "pointer",
        };

        // const isActive = checkForGradientMatch(gradient, gradientOption);
        const isActive = index === selectedGradientIndex;
        const isLight = colorIsLight(color);

        const handleSelect = (selectedIndex) => {
          setSelectedGradientIndex(selectedIndex);
          
          const option = allGradients[selectedIndex];
          if (onSelect) {
            onSelect(option);
          }
        };

        return (
          <GradientPreview
            key={index}
            data-cy={`Gradient_Option_${index}`}
            style={gradientStyle}
            onClick={() => handleSelect(index)}
            $isActive={isActive}
          >
            {isActive && (
              <div
                style={{ position: "absolute", bottom: "2px", right: "2px" }}
              >
                <FnrIcon
                  icon="check-circle fas"
                  style={{ color: isLight ? "black" : "white" }}
                />
              </div>
            )}
          </GradientPreview>
        );
      })}
    </Wrapper>
  );
}

GradientSelector.propTypes = {
  color: string.isRequired,
  initialGradient: arrayOf(string),
  onSelect: func,
};


const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
`
const GradientPreview = styled.button`
  position: relative;
  border: none;
  box-shadow: none;
`;

export default GradientSelector;